// @flow

import React from 'react';
import { Grid, Col, Carousel } from 'react-bootstrap/lib';
import moment from 'moment';
import styler from 'react-styling';
import radium from 'radium';

import ArrayMethods from '../../libs/ArrayMethods';
import { MEETINGROOMS_OVERVIEW_NUMBER_EVENTS } from '../../../../config';
import breakpoints from '../../../css/breakpoints';

function _createStyle(theme: string) {
  return styler `
    Container
      display: table
      width: calc(100% + 30px)
      margin-left: -15px
      padding: 20px 30px
      border-bottom: 1px solid ${theme === 'dark' ? '#0C1428' : '#CCC'}
      font-size: 2.5vw
      @media screen and (max-width: ${breakpoints.MEDIUM_AND_ABOVE}px)
        font-size: 3.3vw
    Time
      position: absolute
      right: 45px
      @media screen and (max-width: ${breakpoints.MEDIUM_AND_ABOVE}px)
        position: relative
        right: 0
    TimeText
      text-transform: capitalize
    Title
      font-size: 60%
  `;
}

type Props = {
  events: Array<Object>,
  clock: moment,
  theme: string,
};

export const MeetingroomOverviewCarousel = (props: Props) => {
  const { events, clock } = props;
  const style = _createStyle(props.theme);
  const eventsChunked = ArrayMethods.chunk(events, MEETINGROOMS_OVERVIEW_NUMBER_EVENTS);
  return (
    <Carousel bsClass="carousel" className={props.theme === 'light' ? 'light-carousel' : null}>
      {eventsChunked.map((slide, index) => (
        <Carousel.Item key={index}>
          {slide.map((e, indx) => (
            <Grid fluid key={indx}>
              <div style={style.Container}>
                <Col xs={12} sm={12} md={3} lg={3}>
                  <p>{e.meetingRoom}</p>
                </Col>
                <Col xs={5} sm={6} md={4} lg={4}>
                  {
                    e.organizer && e.title !== e.organizer.displayName ? (
                      <p>{e.organizer.displayName}</p>
                    ) : null
                  }
                  <p style={style.Title}>{e.title}</p>
                </Col>
                <Col xs={4} sm={3} md={3} lg={3} style={style.TimeText}>
                  <p>{e.start.diff(clock) < 0 ? 'Now' : clock.to(e.start)}</p>
                </Col>
                <div xs={4} sm={3} md={3} lg={3} style={style.Time} className="text-right">
                  <p>{e.start.format('HH:mm')}–{e.end.format('HH:mm')}</p>
                </div>
              </div>
            </Grid>
          ))}
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export default radium(MeetingroomOverviewCarousel);



// WEBPACK FOOTER //
// ./src/js/Components/MeetingRooms/MeetingroomOverviewCarousel.js